export default "__VITE_ASSET__DH_kfg$R__"